"use client"

import type { CommunityPost } from "@/lib/community/types"
import { WorkflowShowcase } from "./workflow-showcase"
import { TeamShowcase } from "./team-showcase"
import { AgentShowcase } from "./agent-showcase"
import { SkillShowcase } from "./skill-showcase"
import { ToolShowcase } from "./tool-showcase"

interface PostShowcaseProps {
  post: CommunityPost
}

export function PostShowcase({ post }: PostShowcaseProps) {
  switch (post.abilityType) {
    case "workflow":
      return post.workflowNodes?.length ? (
        <WorkflowShowcase nodes={post.workflowNodes} />
      ) : null

    case "agent-team":
      return (
        <>
          {post.teamDetail?.agents?.length ? (
            <TeamShowcase agents={post.teamDetail.agents} />
          ) : null}
          {post.workflowNodes?.length ? (
            <WorkflowShowcase nodes={post.workflowNodes} />
          ) : null}
        </>
      )

    case "agent":
      return (
        <AgentShowcase
          capabilities={post.capabilities}
          agentDetail={post.agentDetail}
        />
      )

    case "skill":
      return post.skillDetail ? (
        <SkillShowcase skillDetail={post.skillDetail} />
      ) : null

    case "tool":
      return post.toolDetail?.tools?.length ? (
        <ToolShowcase toolDetail={post.toolDetail} />
      ) : null

    default:
      return null
  }
}
